import { StyleSheet } from 'aphrodite'

// import user from './user'
import list from './list'

export default {
  list: StyleSheet.create(list)
  // user: StyleSheet.create(user)
}



// WEBPACK FOOTER //
// ./src/components/Community/partials/UserTable/style/ColorBlind/index.js